import { useQuery } from '@tanstack/react-query';
import { fetchUserDataExport } from '../../api/gdpr';

export const useGetUserDataExport = () => {
  return useQuery({
    queryKey: ['GET_USER_DATA_EXPORT'],
    queryFn: fetchUserDataExport,
    staleTime: 60000, // 1 minute
    refetchOnWindowFocus: false,
  });
};
